import styled from 'styled-components';

export const ContentWrapperStyled = styled.li`
	display: flex;
	flex-direction: column;
	padding-bottom: ${({ theme }) => theme.variables.padding}px;
	margin-bottom: ${({ theme }) => theme.variables.margin}px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.quaternaryColor};
`;

export const HeaderWrapperStyled = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	padding-bottom: ${({ theme }) => theme.variables.padding}px;
`;

export const InformationContainerStyled = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
`;

export const InformationWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const MetricWrapperStyled = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding-top: ${({ theme }) => theme.variables.padding * 0.25}px;

	@media (max-width: ${({ theme }) => `${theme.variables.wrapBreakPoint}px`}) {
		flex-direction: column;
	}
`;

export const LinkWrapperStyled = styled.div`
	padding-top: ${({ theme }) => theme.variables.padding}px;
`;
